import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export default (props) => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.title]);
    return _jsxs("div", { className: "d-flex flex-column min-vh-100 bg-light", children: [_jsxs("header", { className: "bg-primary text-white px-4 py-3 d-flex align-items-center justify-content-between", children: [_jsx("h4", { className: "m-0", children: props.title }), !!props.exitTo && (_jsx("button", { className: "btn btn-light", onClick: props.exitTo, children: "Exit" }))] }), _jsx("main", { className: "flex-grow-1 p-4", children: props.children })] });
};
